import React from "react";
import { useFieldArray } from "react-hook-form";
import Input from "../Input/Input";
import TopLabelCustomSelectBox from "../TopLabelReactSelect/TopLabelReactSelect";
import { StatusOptions } from "../../utils/constants";

import styles from "./AcademicActivites.module.css";

const Dissertations = ({ register, control, errors, disabled }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "dissertations",
  });

  React.useEffect(() => {
    if (fields.length === 0) {
      append({
        level: "",
        title: "",
        status: "",
        institution: "",
        year: "",
      });
    }
  }, [fields, append]);

  return (
    <div className={styles.borderBox}>
      <div className={styles.heading}>
        <h2>B. Dissertations / Student Projects</h2>

      </div>
      {fields.map((item, idx) => (
        <div className={styles.grid3} key={item.id}>
          <Input
            label="Level"
            name={`dissertations[${idx}].level`}
            register={register}
            errors={errors}
            disabled={disabled}
          />

          <Input
            label="Title"
            name={`dissertations[${idx}].title`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <TopLabelCustomSelectBox
            label="Status"
            name={`dissertations[${idx}].status`}
            register={register}
            errors={errors}
            placeholder="Select"
            options={StatusOptions}
            control={control}
            disabled={disabled}
          />

          <Input
            label="Institution"
            name={`dissertations[${idx}].institution`}
            register={register}
            errors={errors}
            disabled={disabled}
          />

          <Input
            label="Year"
            name={`dissertations[${idx}].year`}
            register={register}
            errors={errors}
            year
            disabled={disabled}
          />
          {idx > 0 && !disabled && (
            <button
              type="button"
              className={styles.remove}
              onClick={() => remove(idx)}
            >
              X
            </button>
          )}
        </div>
      ))}

      <div className={styles.buttonOuter}>
        <div></div>
        {!disabled && (
          <button
            type="button"
            className={styles.button}
            onClick={() =>
              append({
                level: "",
                title: "",
                status: "",
                institution: "",
                year: "",
              })
            }
          >
            + Add More
          </button>
        )}
      </div>
    </div>
  );
};

export default Dissertations;
